export default __webpack_public_path__ + "static/media/HeroImg.4401c30e.png";